import React, { useState, useEffect, useCallback } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import Heading from "../../../../../common/element/Heading";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import InvoiceList from "./InvoiceList";
import ReactPaginate from "react-paginate";
import { Pagination } from "../../../../../common/pagination";
import Dialog from "../../../../../common/element/Dialog/Dialog";
import { setBreadcrumbs } from "../../../../../redux/classes/breadcrumbsSlice";
import moment from "moment";
import { AdminGetAllProviderInvoices } from "../../../../../actions/provider-portal/invoices/AdminGetAllProviderInvoices";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { UpdateProviderBillingCard } from "../../../../../actions/provider-portal/billing/UpdateProviderBillingCard";
import { GetSavedCards } from "../../../../../actions/provider-portal/billing/GetSavedCards";
import ThreeDotBouncing from "../../../../../common/element/PageLoader";
import ExpiredSubscription from "../../../components/template/ExpiredSubscription";
const Invoices = () => {
  const dispatch = useDispatch();
  const { isSubscribed, next_renewal_date } = useSelector((state) => state?.providerSubscription);
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
  const { allFunctions } = useSelector((state) => state);
  const [countData, setCountData] = useState(0);
  const [loadData, setLoadData] = useState(false);
  const [filterpage, setfilterpage] = useState(1);
  const [pdfDownloadSuccessDialog, setPdfDownloadSuccessDialog] =
    useState(false);
  const [filterlimit, setfilterlimit] = useState(10);
  const [filterorder, setFilterOrder] = useState("desc");
  const [filtersort, setFiltersort] = useState("created_date");

  const [totalPages, setTotalPages] = useState(1);
  const [allInvoicesData, setAllInvoicesData] = useState([]);
  const { specificClientDetails } = useSelector((state) => state);
  const stripe = useStripe();
  const elements = useElements();
  const [isSavingCard, setIsSavingCard] = useState(false);
  const [cardError, setCardError] = useState("");
  const [savedCard, setSavedCard] = useState(null);
  const [isCardUpdateSuccess, setIsCardUpdateSuccess] = useState(false);
  const [cardholderName, setCardholderName] = useState("");
  useEffect(() => {
    dispatch(GetSavedCards({ provider_org_id: loginUserData?.organisation_id }))
      .then((resp) => {
        if (resp?.success && Array.isArray(resp?.data)) {
          const def = resp.data.find(c => c.default_card) || resp.data[0];
          if (def) setSavedCard(def);
        }
      });
  }, []);
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Invoices",
          url: `/provider/invoices`,
          home: "/provider/dashboard",
        },
      ])
    );
  }, [specificClientDetails]);

  const onGetAllInvoiceData = useCallback(async () => {
    let payload = {
      page: filterpage,
      limit: filterlimit,
      provider_org_id: loginUserData?.organisation_id,
      order: filterorder,
      sort: filtersort,
    };

    dispatch(AdminGetAllProviderInvoices(payload)).then((response) => {
      if (response.success) {
        setLoadData(true);
        setAllInvoicesData(response?.data?.rows);
        setCountData(response.data?.count);
        setTotalPages(Math.ceil(response.data?.length / filterlimit));
      } else {
        setLoadData(true);
      }
    });
  }, [dispatch, filterpage, filterorder, filtersort, filterlimit]);

  useEffect(() => {
    onGetAllInvoiceData();
  }, [filterpage, filterorder, filtersort, filterlimit]);

  const handleSort = (column) => {
    if (column === filtersort) {
      setFilterOrder(filterorder === "asc" ? "desc" : "asc");
    } else {
      setFiltersort(column);
      setFilterOrder(filterorder === "asc" ? "desc" : "asc");
    }
  };
  const handlePageChange = ({ selected }) => {
    setfilterpage(selected + 1);
  };

  const closeDownloadSuccessPdf = () => {
    setPdfDownloadSuccessDialog(false);
    setIsCardUpdateSuccess(false);
  };

  const handleSaveCard = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setCardError("");
    setIsSavingCard(true);
    try {
      const cardNumberElement = elements.getElement(CardNumberElement);
      if (!cardNumberElement) {
        setCardError("Something went wrong. Please reload the page and try again.");
        setIsSavingCard(false);
        return;
      }
      const { error, token } = await stripe.createToken(cardNumberElement, {
        name: cardholderName,
      });
      if (error) {
        setCardError(error.message || "Unable to save card.");
        setIsSavingCard(false);
        return;
      }
      const payload = {
        cardToken: token.id,
        makedefault: 1,
        provider_org_id: loginUserData?.organisation_id,
      };
      const resp = await dispatch(UpdateProviderBillingCard(payload));
      if (resp?.success) {
        // Refresh card data from API
        const cardResp = await dispatch(GetSavedCards({ provider_org_id: loginUserData?.organisation_id }));
        if (cardResp?.success && Array.isArray(cardResp?.data)) {
          const def = cardResp.data.find(c => c.default_card) || cardResp.data[0];
          if (def) setSavedCard(def);
        }
        // Clear card element and show success
        elements.getElement(CardNumberElement).clear();
        elements.getElement(CardExpiryElement).clear();
        elements.getElement(CardCvcElement).clear();
        setIsCardUpdateSuccess(true);
        setPdfDownloadSuccessDialog(true);
      } else {
        setCardError(resp?.message || "Unable to update card. Try again.");
      }
    } catch (err) {
      setCardError("Unexpected error. Try again.");
    } finally {
      setIsSavingCard(false);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: "16px",
        color: "#333",
        "::placeholder": {
          color: "#a0aec0",
        },
      },
      invalid: { color: "#e53e3e" },
    },
  };
  return (
    <React.Fragment>
      <div className=" my-10 p-4 font-sans">
        {/* Billing Header Section */}
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">Billing</h2>
          <p className="text-sm text-gray-500 mt-1">
            {loginUserData?.userName?.next_renewal_date ? (
              <>
                Your annual subscription will automatically renew on{" "}
                <span className="font-bold">
                  {moment(loginUserData.userName.next_renewal_date).format("MMMM D, YYYY")}
                </span>
                {savedCard?.last4 ? (
                  <>
                    , billed to card ending in{" "}
                    <span className="font-bold">{savedCard.last4}</span>.
                  </>
                ) : (
                  "."
                )}
              </>
            ) : (
              "Manage your payment methods and billing information."
            )}
          </p>
        </div>

        {/* Card Update Form Box */}
        <div className="bg-[#F9FAFB] border border-[#EAECF0] max-w-[652px] rounded-[12px]bg-white rounded-lg shadow-md border border-gray-200 p-6">
          <h3 className="text-lg font-medium text-gray-800 mb-5">Update your card on file</h3>
          <form onSubmit={handleSaveCard}>

            <div className="space-y-4">
              {savedCard ? (
                <div className={`flex items-center justify-between p-3 border rounded-md ${savedCard?.is_expired ? 'border-red-300 bg-red-50' : savedCard?.expiry_status === 'expiring_this_month' || savedCard?.expiry_status === 'expiring_next_month' ? 'border-yellow-300 bg-yellow-50' : ''}`}>
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <div className="text-sm text-gray-700">

                        <span className="font-mono tracking-widest mr-3">**** **** **** {savedCard?.last4}</span>
                        <span className="capitalize">{savedCard?.brand}</span>
                      </div>
                      <div className="text-sm text-gray-500">
                        {String(savedCard?.exp_month).padStart(2, '0')}/{savedCard?.exp_year}
                      </div>
                    </div>
                    {savedCard?.is_expired && (
                      <p className="text-xs text-red-600 mt-1 font-semibold">⚠️ This card has expired. Please update it to continue billing.</p>
                    )}
                    {savedCard?.expiry_status === 'expiring_this_month' && (
                      <p className="text-xs text-yellow-700 mt-1 font-semibold">⚠️ This card expires this month. Please update it soon.</p>
                    )}
                    {savedCard?.expiry_status === 'expiring_next_month' && (
                      <p className="text-xs text-yellow-700 mt-1">ℹ️ This card expires next month. Consider updating it.</p>
                    )}
                  </div>
                </div>
              ) : (
                <p className="text-sm text-gray-500">No card on file.</p>
              )}

              <div className="flex gap-4">

                <div className="basis-[70%]">
                  <label
                    htmlFor="cardholder-name"
                    className="block text-sm font-medium text-gray-700 mb-[6px] block text-[12px] font-medium text-[#344054]
"
                  >
                    Name on card
                  </label>
                  <input
                    id="cardholder-name"
                    type="text"
                    value={cardholderName}
                    onChange={(e) => setCardholderName(e.target.value)}
                    placeholder="Name on card"
                    className="w-full leading-normal border border-[1px] border-[#D0D5DD] rounded-lg p-[8px_12px] focus:ring-blue-500 transition"
                  />
                </div>


                <div className="basis-[30%]">
                  <label className="block text-sm font-medium text-gray-700 mb-[6px] block text-[12px] font-medium text-[#344054]
">
                    Expiry
                  </label>
                  <div className="border border-[1px] border-[#D0D5DD] rounded-lg p-[8px_12px] bg-[#fff] rounded-lg focus-within:border-blue-500 transition">
                    <CardExpiryElement options={cardElementOptions} />
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="basis-[70%]">
                  <label className="mb-[6px] block text-[12px] font-medium text-[#344054]
">
                    Card number
                  </label>
                  <div className="w-full leading-normal border border-[1px] border-[#D0D5DD] rounded-lg bg-[#fff]
 p-[8px_12px] focus:ring-blue-500 transition">
                    <CardNumberElement options={cardElementOptions} />
                  </div>
                </div>


                <div className="basis-[30%]">
                  <label className="mb-[6px] block text-[12px] font-medium text-[#344054]
">
                    CVV
                  </label>

                  <div className="w-full bg-[#fff]
 leading-normal border border-[1px] border-[#D0D5DD] rounded-lg p-[8px_12px] focus:ring-blue-500 transition">
                    <CardCvcElement options={cardElementOptions} />
                  </div>
                </div>
              </div>

              {cardError && (
                <p className="text-red-500 text-sm">{cardError}</p>
              )}

              <div className="flex space-x-3 pt-1">
                <button
                  type="button"
                  className="p-[10px_16px]
 text-sm font-semibold border border-[1px] border-[#F2F4F7]  text-gray-600 rounded-[8px]
 hover:bg-gray-100 transition duration-150"
                  onClick={() => {
                    elements.getElement(CardNumberElement).clear();
                    elements.getElement(CardExpiryElement).clear();
                    elements.getElement(CardCvcElement).clear();
                    setCardholderName("");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSavingCard}
                  className="p-[10px_16px]
 text-sm font-semibold text-white bg-[#5786CC] border border-[1px] border-[#5FB8EA]
 rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-[8px]
 transition duration-150"
                >
                  {isSavingCard ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {isSubscribed ? <ExpiredSubscription /> :
        <>
          <div>
            <Heading>Invoice</Heading>
            <p className="text-gray-600 my-3">
              {/* Non morbi vitae turpis leo scelerisque nisl phasellus nisi. Commodo. */}
            </p>
          </div>
          {/* <Filter /> */}
          <InvoiceList
            loadData={loadData}
            handleSort={handleSort}
            filtersort={filtersort}
            filterorder={filterorder}
            allInvoicesData={allInvoicesData}
          />
          {!loadData && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}

          {loadData && (
            <div className="flex justify-between mt-3">
              <Pagination
                totalCount={countData}
                pageNumber={filterpage}
                displayPage={allInvoicesData?.length}
                UpdatePageLimit={setfilterlimit}
                UpdatePage={setfilterpage}
              />
              {countData > 0 && (
                <ReactPaginate
                  className="flex justify-content-end p-2 align-items-center pagination-wrap"
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={totalPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  previousLinkClassName={"prev-link"}
                  nextLinkClassName={"page-link"}
                  breakLinkClassName={"prev-link"}
                  previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                  nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                  pageLinkClassName={"px-4 rounded-md"}
                  activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                  disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                  renderOnZeroPageCount={null}
                  forcePage={filterpage - 1}
                />
              )}
            </div>
          )}
          <Dialog
            isOpen={pdfDownloadSuccessDialog}
            onClose={closeDownloadSuccessPdf}
            onRequestClose={closeDownloadSuccessPdf}
            bodyOpenClassName="overflow-hidden"
            className="customAlert"
          >
            <div className="px-6 pt-6">
              <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
                <svg
                  width="49"
                  height="49"
                  viewBox="0 0 49 49"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.894531"
                    y="0.585938"
                    width="48"
                    height="48"
                    rx="24"
                    fill="#D1FADF"
                  />
                  <path
                    d="M26.8945 14.8555V18.986C26.8945 19.5461 26.8945 19.8261 27.0035 20.04C27.0994 20.2282 27.2524 20.3811 27.4405 20.477C27.6545 20.586 27.9345 20.586 28.4945 20.586H32.6251M28.8945 25.5859H20.8945M28.8945 29.5859H20.8945M22.8945 21.5859H20.8945M26.8945 14.5859H21.6945C20.0144 14.5859 19.1743 14.5859 18.5326 14.9129C17.9681 15.2005 17.5091 15.6595 17.2215 16.224C16.8945 16.8657 16.8945 17.7058 16.8945 19.3859V29.7859C16.8945 31.4661 16.8945 32.3062 17.2215 32.9479C17.5091 33.5124 17.9681 33.9713 18.5326 34.259C19.1743 34.5859 20.0144 34.5859 21.6945 34.5859H28.0945C29.7747 34.5859 30.6148 34.5859 31.2565 34.259C31.821 33.9713 32.2799 33.5124 32.5676 32.9479C32.8945 32.3062 32.8945 31.4661 32.8945 29.7859V20.5859L26.8945 14.5859Z"
                    stroke="black"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <p className="text-base text-gray-900 font-semibold text-center mt-4">
                {isCardUpdateSuccess ? "Card updated successfully! All recurring payments will use the new card." : "All PDFs downloaded successfully!"}
              </p>
            </div>
            <div className="mt-8 flex justify-between pb-6 px-6">
              <BtnLight onClick={() => closeDownloadSuccessPdf()}>Close</BtnLight>
            </div>
          </Dialog>
        </>
      }

    </React.Fragment>
  );
};
export default Invoices;
